import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleGetRequest } from '../../services/GetTemplate';

const lkpStatusSlice = createSlice({
    name: "lkpAccountStatus",
    initialState: {
        isLoading: false,
        data: [],
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(getLkpAccountStatus.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getLkpAccountStatus.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        builder.addCase(getLkpAccountStatus.rejected, (state, action) => {
            state.isError = true;
        })
    }
})

export const getLkpAccountStatus = createAsyncThunk("getLkpAccountStatus", async () => {
    const res = await handleGetRequest(`/configuration/v1/lookups/getAccountStatus/LKP_ACCOUNT_STATUS:*`);
    return res?.payLoad;
});

export default lkpStatusSlice.reducer